import useMediaBreakpoint, { type MediaBreakpoint } from "./useMediaBreakpoint";

function useMediaBreakpointDown(breakpoint: MediaBreakpoint): boolean {
   return useMediaBreakpoint("down", breakpoint);
}

export default useMediaBreakpointDown;